import React, { useEffect, useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { logout } from "../../Redux/authSlice";
import EventBus from "../../middleware/eventBus";
import {
  applySidebarCollapsed,
  initSidebarState,
  isSidebarCollapsed,
  toggleSidebarCollapsed,
} from "../../utils/sidebarState";
import { LOGO_PRIMARY } from "../../utils/assetPaths";

import AdminMenu from "./AdminMenu";
import AdminBottomNav from "./AdminBottomNav";
import DoctorBottomNav from "./DoctorBottomNav";
import PatientBottomNav from "./PatientBottomNav";
import DoctorMenu from "./DoctorMenu";
import PatientMenu from "./PatientMenu";

export default function Header() {
  const dispatch = useDispatch();
  const authData = useSelector((state) => state.auth);
  const userTypeLabel =
    authData.user?.user_type?.name ?? authData.panel ?? "Patient";
  const logOut = useCallback(() => { 
    dispatch(logout());
  }, [dispatch]);

  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const syncSidebarCollapsed = useCallback(() => {
    setSidebarCollapsed(
      typeof document !== "undefined" &&
        document.body.classList.contains("sidebar-collapse")
    );
  }, []);

  const toggleSidebar = useCallback((e) => {
    e.preventDefault();
    const body = document.body;
    if (window.innerWidth < 768) {
      body.classList.toggle("sidebar-open");
    } else {
      const collapsed = toggleSidebarCollapsed();
      setSidebarCollapsed(collapsed);
    }
  }, []);

  const toggleDesktopSidebar = useCallback((e) => {
    e.preventDefault();
    if (window.innerWidth < 768) {
      return;
    }

    const collapsed = toggleSidebarCollapsed();
    setSidebarCollapsed(collapsed);
  }, []);

  useEffect(() => {
    initSidebarState();
    syncSidebarCollapsed();

    const handleResize = () => {
      if (window.innerWidth >= 768) {
        document.body.classList.remove("sidebar-open");
        applySidebarCollapsed(isSidebarCollapsed());
        syncSidebarCollapsed();
      } else {
        document.body.classList.remove("sidebar-collapse");
        syncSidebarCollapsed();
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [syncSidebarCollapsed]);

  useEffect(() => {
    EventBus.on("logout", () => {
      logOut();
    });

    return () => {
      EventBus.remove("logout");
    };
  }, [logOut]);

  useEffect(() => {
    const mobileNavPanels = ["Admin", "Doctor", "Patient"];
    if (mobileNavPanels.includes(authData?.panel)) {
      document.body.classList.add("admin-mobile-nav");
    } else {
      document.body.classList.remove("admin-mobile-nav");
    }

    return () => {
      document.body.classList.remove("admin-mobile-nav");
    };
  }, [authData?.panel]);

  if (!authData.isLoggedIn || !authData.user) {
    return <Navigate to="/login" />;
  }

  return (
    <div>
      <header className="main-header">
        <div className="d-flex align-items-center logo-box justify-content-start">
          <Link to="#" className="logo">
            <div className="logo-lg">
              <span className="light-logo">
                <img
                  src={LOGO_PRIMARY}
                  alt="MicroLab"
                  className="main-header__logo-img"
                />
              </span>
            </div>
          </Link>
          <button
            type="button"
            className="sidebar-desktop-toggle"
            onClick={toggleDesktopSidebar}
            aria-label={sidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
            title={sidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
          >
            <i
              className={sidebarCollapsed ? "ti-angle-right" : "ti-angle-left"}
              aria-hidden="true"
            />
          </button>
        </div>

        <nav className="navbar navbar-static-top">
          <div className="navbar-custom-menu r-side">
            <div className="navbar-user-info">
              <p className="navbar-user-info__name">{authData.user.name}</p>
              <span className="navbar-user-info__type">{userTypeLabel}</span>
            </div>
          </div>

          <div className="app-menu sidebar-mobile-toggle">
            <ul className="header-megamenu nav">
              <li className="btn-group nav-item">
                <a
                  href="#"
                  className="waves-effect waves-light nav-link push-btn btn-primary-light"
                  role="button"
                  onClick={toggleSidebar}
                >
                  <i className="icon-Menu">
                    <span className="path1"></span>
                    <span className="path2"></span>
                  </i>
                </a>
              </li>
              {/* <li className="btn-group d-lg-inline-flex d-none">
                <div className="app-menu">
                  <div className="search-bx mx-5">
                    <form>
                      <div className="input-group">
                        <input
                          type="search"
                          className="form-control"
                          placeholder="Search"
                        />
                        <div className="input-group-append">
                          <button
                            className="btn"
                            type="submit"
                            id="button-addon3"
                          >
                            <i className="icon-Search">
                              <span className="path1"></span>
                              <span className="path2"></span>
                            </i>
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </li> */}
            </ul>
          </div>
        </nav>
      </header>
      {/* {
        m1 && <DoctorMenu/>
      } */}
      {/* Call Menu */}
      {authData.panel === "Doctor" ? <DoctorMenu /> : <></>}
      {authData.panel === "Admin" ? <AdminMenu /> : <></>}
      {authData.panel === "Admin" ? <AdminBottomNav /> : <></>}
      {authData.panel === "Doctor" ? <DoctorBottomNav /> : <></>}
      {authData.panel === "Patient" ? <PatientMenu /> : <></>}
      {authData.panel === "Patient" ? <PatientBottomNav /> : <></>}
    </div>
  );
}
